import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.ticketing.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcadmin-ticketing-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.ticketing.item/view.scss */
/* src/app/portal.gsdcadmin.ticketing.item/view.scss: no such file or directory */`],
})
export class PortalGsdcadminTicketingItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() ticket_id: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public comments: any = [];
    public tags: any = [];
    public comment_text: any = '';
    public commentFiles: any = [];
    public isSendingComment: boolean = false;
    public isUpdating: boolean = false;

    public item: any = {};
    public editor: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load(showNotice = true) {
        const { code, data } = await wiz.call("get", { id: this.ticket_id });
        if (code !== 200 || !data?.item) {
            if (!showNotice) throw new Error("TICKET_LOAD_FAILED");
            return;
        }
        this.item = data.item;
        this.comments = Array.isArray(data.comments) ? data.comments.map(comment => ({
            ...comment, extra: this.fileMetadata(comment.extra)
        })) : [];
        this.tags = this.metadataArray(data.item.tag).filter(tag => typeof tag === 'string');
        this.item.extra = this.fileMetadata(this.item.extra);
        this.item.start_date = moment(this.item.start_date).format("YYYY-MM-DD");
        this.item.due_date = moment(this.item.due_date).format("YYYY-MM-DD");

        await this.service.render();
        const notice = this.notificationMessage(data);
        if (showNotice && notice) {
            await this.service.loading.hide();
            await this.service.alert.warning(notice);
        }
        return data;
    }

    private notificationMessage(data: any): string {
        if (!data?.notification_warning) return "";
        return data.notification_queued === true
            ? "처리는 완료되었습니다. 알림 메일 발송이 지연되고 있습니다. 운영자에게 문의해주세요."
            : "처리는 완료되었지만 알림 메일 예약 여부를 확인하지 못했습니다. 같은 내용을 다시 등록하지 말고 운영자에게 문의해주세요.";
    }

    private metadataArray(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (typeof value !== 'string') return [];
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (_) { return []; }
    }

    private fileMetadata(value: any): any[] {
        return this.metadataArray(value).filter(file => file && typeof file === 'object'
            && typeof file.name === 'string' && typeof file.url === 'string');
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async update() {
        if (this.isUpdating) return;
        this.isUpdating = true;
        let saved = false, refreshFailed = false, notice = "";
        let errorMessage = "저장하지 못했습니다. 잠시 후 다시 시도해주세요.";
        try {
            await this.service.loading.show();
            const { code, data } = await wiz.call("update", { ticketID: this.ticket_id, status: this.item.status });
            if (code === 200) {
                saved = true;
                notice = this.notificationMessage(data);
                try {
                    const loaded = await this.load(false);
                    notice = notice || this.notificationMessage(loaded);
                } catch (_) {
                    refreshFailed = true;
                }
            } else {
                errorMessage = typeof data === "string" ? data : data?.message || errorMessage;
            }
        } catch (_) {
            refreshFailed = saved;
        } finally {
            this.isUpdating = false;
            await this.service.loading.hide();
            await this.service.render();
        }
        if (!saved) return await this.service.alert.error(errorMessage);
        if (notice) await this.service.alert.warning(notice);
        if (refreshFailed) return await this.service.alert.warning("처리는 완료되었지만 화면을 새로 고치지 못했습니다. 페이지를 새로고침해주세요.");
        if (!notice) await this.service.alert.success("저장되었습니다.");
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.item.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/admin/ticketing');
    }

    private hasCommentContent(text: string): boolean {
        const parsed = new DOMParser().parseFromString(text || '', 'text/html');
        const plainText = (parsed.body.textContent || '').replace(/\u00a0/g, ' ').trim();
        const hasEmbeddedContent = parsed.body.querySelector('img, table, pre, code, blockquote') !== null;
        return plainText.length > 0 || hasEmbeddedContent;
    }

    public async sendComment() {
        if (this.isSendingComment) return;
        this.comment_text = this.editor.data.get();
        if (!this.hasCommentContent(this.comment_text)) return await this.service.alert.error("내용을 입력해주세요.");

        this.isSendingComment = true;
        let saved = false, refreshFailed = false, notice = "";
        try {
            await this.service.loading.show();
            const files = JSON.stringify(this.commentFiles);
            const { code, data } = await wiz.call("comment", { ticket_id: this.ticket_id, text: this.comment_text, files });
            if (code === 200) {
                saved = true;
                notice = this.notificationMessage(data);
                this.comment_text = "";
                this.commentFiles = [];
                this.editor.data.set("");
                try {
                    const loaded = await this.load(false);
                    notice = notice || this.notificationMessage(loaded);
                } catch (_) {
                    refreshFailed = true;
                }
            }
        } catch (_) {
            refreshFailed = saved;
        } finally {
            this.isSendingComment = false;
            await this.service.loading.hide();
            await this.service.render();
        }

        if (!saved) return await this.service.alert.error("댓글 등록에 실패했습니다.");
        if (notice) await this.service.alert.warning(notice);
        if (refreshFailed) return await this.service.alert.warning("처리는 완료되었지만 화면을 새로 고치지 못했습니다. 페이지를 새로고침해주세요.");
        if (!notice) await this.service.alert.success("댓글이 등록되었습니다.");
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }

    public async uploadCommentFile() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.commentFiles) this.commentFiles = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            // fd.append('upload', files[i]);
            // let fdurl = '/file/upload';
            fd.append('upload', files[i], files[i].name.includes(".") ? files[i].name : `${files[i].name}.jpg`);
            let fdurl = '/file/upload';
            if (!files[i].name.includes(".")) fdurl = fdurl + "/noext";

            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            this.commentFiles.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        this.service.render();
    }

    public async removeCommentFile(file) {
        this.commentFiles.remove(file);
        this.service.render();
    }

    public async buildEditor() {
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.comment_text);
    }

    public statusLabels: { [key: string]: string } = {
        'pending': '접수대기',
        'received': '접수완료',
        'processing': '처리중',
        'completed': '처리완료'
    };

    public getStatusLabel(status: string): string {
        return this.statusLabels[status] || status; // 변환된 값이 없으면 원래 값을 반환
    }

    public getStatusColor(status: string) {
        switch (status) {
            case 'pending': return 'bg-gray-400 text-white';
            case 'received': return 'bg-gray-100 text-green-800';
            case 'process': return 'bg-emerald-100 text-yellow-800';
            case 'finish': return 'bg-indigo-100 text-gray-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }
}

export default PortalGsdcadminTicketingItemComponent;